export const PALETTE = {
	blue: {
		10: '#EBF7FE',
		25: '#E2F4FD',
		50: '#BDE5F9',
		75: '#5FC8FD',
		100: '#32B2F3',
		125: '#2D91CA',
		150: '#2971A1',
		175: '#21496B',
		200: '#0D3C5E',
		DEFAULT: '#32B2F3',
	},
	neutral: {
		5: '#F8FAFC',
		10: '#F2F5F9',
		25: '#E3E8EF',
		50: '#D5DCE6',
		75: '#B1BBCA',
		100: '#8F9CAF',
		125: '#76859A',
		150: '#5E6F85',
		175: '#374A63',
		200: '#142A45',
		225: '#3d4859', // ?
		250: '#2c3c51', // ?
		300: '#142a45',
	},
	green: {
		10: '#F2FBF7',
		25: '#E4FBEF',
		50: '#C4F2DB',
		75: '#50CE8D',
		100: '#00B557',
		125: '#04984B',
		150: '#08753C',
		175: '#0E4E2C',
		200: '#123E36',
		DEFAULT: '#00B557',
	},
	orange: {
		10: '#FFF5E6',
		25: '#FCEED9',
		50: '#F9D9AA',
		75: '#ED974F',
		100: '#E87B35',
		125: '#D9622B',
		150: '#B34A22',
		175: '#73321B',
		200: '#6C5F4C',
		DEFAULT: '#E87B35',
	},
	red: {
		10: '#FEF6F5',
		25: '#FEECEB',
		50: '#FBD1CE',
		75: '#FF7A70',
		100: '#F44236',
		125: '#CA3A31',
		150: '#AA2E26',
		175: '#8C2822',
		200: '#4F4855',
		DEFAULT: '#F44236',
	},
	yellow: {
		10: '#FFFAE6',
		25: '#FDF7DD',
		50: '#F7E8AB',
		75: '#E2B53E',
		100: '#C19A2F',
		125: '#A58323',
		150: '#8A6C17',
		175: '#554000',
		200: '#6C664C',
		DEFAULT: '#C19A2F',
	},
	purple: {
		10: '#F0F1FA',
		25: '#EBECFF',
		50: '#D0D4FB',
		75: '#A8B4F6',
		100: '#7378ED',
		125: '#6163ED',
		150: '#4F4CE0',
		175: '#39369C',
		200: '#1A205E',
		DEFAULT: '#7378ED',
	},
}
export const CONTEXTUAL = {
	brand: PALETTE.blue,
	info: PALETTE.blue,
	epic: PALETTE.purple,
	alert: PALETTE.yellow,
	success: PALETTE.green,
	danger: PALETTE.red,
	warning: PALETTE.orange,
}
